import 'react-toastify/dist/ReactToastify.css';

import React, { lazy } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import AdminLayout from '../layouts/AdminLayout';
import AllClassroom from '../pages/admin/classroom/AllClassroom';
import AllCourses from '../pages/admin/courses/AllCourses';
import ApprovalRequest from '../pages/admin/approvalRequest/ApprovalRequest';
import ClassroomAssessments from '../pages/admin/classroom/ClassroomAssessments';
import ClassroomAssignments from '../pages/admin/classroom/ClassroomAssignments';
import ClassroomCommunity from '../pages/admin/classroom/ClassroomCommunity';
import ClassroomDashboard from '../pages/admin/classroom/ClassroomDashboard';
import ClassroomLiveClasses from '../pages/admin/classroom/ClassroomLiveClasses';
import ClassroomTrainees from '../pages/admin/classroom/ClassroomTrainees';
import ClassrooomAssessmentDetails from '../pages/admin/classroom/ClassroomAssessmentDetails';
import ClassrooomAssignmentDetails from '../pages/admin/classroom/ClassroomAssignmentDetails';
import QuestionBank from '../pages/admin/questionBank/QuestionBank';


import Announcement from '../pages/admin/announcement/announcement';

import RolesAndAccess from '../pages/admin/roles_and_access/RolesAndAccess';


import CourseAnalytics from '../pages/admin/courses/CourseAnalytics';
import CourseAnalyticsAssessmentDetails from '../pages/admin/courses/CourseAnalyticsAssessmentDetails'
import CourseAnalyticsSurveyDetails from '../pages/admin/courses/CourseAnalyticsSurveyDetails'
import CourseDocument from '../pages/admin/courses/CourseDocument';
import CourseModule from '../pages/admin/courses/CourseModule';
import AdminCourseView from '../pages/admin/courses/AdminCourseView';
import AdminModuleContentView from '../pages/admin/courses/AdminModuleContentView';
import AdminVideoPlayerView from '../pages/admin/courses/CourseVideo/AdminVideoPlayerView';
import AdminDocumentView from '../pages/admin/courses/AdminDocumentView';
import AdminAssessmentView from '../pages/admin/courses/AdminAssessmentView';
import AdminSurveyView from '../pages/admin/courses/AdminSurveyView';
import CourseQuiz from '../pages/admin/courses/CourseQuiz';
import CourseSurvey from '../pages/admin/courses/CourseSurvey';
import CourseVideo from '../pages/admin/courses/CourseVideo';
import Courses from '../pages/admin/courses/Courses';
import CreateCourse from '../pages/admin/courses/CreateCourse';
import CourseCategories from '../pages/admin/courses/categories/CourseCategories';
import Dashboard from '../pages/admin/dashboard/Dashboard';
import ModuleContent from '../pages/admin/courses/ModuleContent';
import NotificationDetails from '../pages/admin/Notifications/NotificationDetails';
import Notifications from '../pages/admin/Notifications/Notifications';
import Profile from '../pages/admin/profile/Profile';
import Settings from '../pages/admin/settings/Settings';
import { ToastContainer } from 'react-toastify';
import TraineeAnalytics from '../pages/admin/trainees/TraineeAnalytics';
import VideoPlayer from '../pages/admin/courses/CourseVideo/VideoPlayer';
import OrganizationDocs from '../pages/admin/OrganizationDocs';
import Surveys from '../pages/admin/Surveys.jsx';
import SurveyBuilder from '../pages/admin/SurveyBuilder.jsx';
import SurveyAssign from '../pages/admin/SurveyAssign.jsx';
import SurveyAnalytics from '../pages/admin/SurveyAnalytics.jsx';







import PromptAssistant from '../pages/admin/PromptAssistant/PromptAssistant';
import ZoomMeeting from '../components/zoom/ZoomMeeting';
import { usePermissions } from '../context/PermissionsContext';
import TermsAndConditions from '../pages/legal/TermsAndConditions';
import PrivacyPolicy from '../pages/legal/PrivacyPolicy';
import CookiePolicy from '../pages/legal/CookiePolicy';
import ProtectedRoute from '../components/ProtectedRoute';







function AdminRoutes() {
  
  return (
    <>
      <Routes>
        {/* Standalone Zoom Meeting Route - No Layout */}
        <Route path="/zoom-meeting" element={<ZoomMeeting />} />

        {/* Legal Routes */}
        <Route path="/legal/terms" element={<TermsAndConditions />} />
        <Route path="/legal/privacy" element={<PrivacyPolicy />} />
        <Route path="/legal/cookies" element={<CookiePolicy />} />

        <Route path="/admin" element={<AdminLayout />}>
          {/* Dashboard */}
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="profile" element={<Profile />} />

          {/* Generic Surveys */}
          <Route path="surveys" element={<Surveys />} />
          <Route path="surveys/:id" element={<SurveyBuilder />} />
          <Route path="surveys/:id/assign" element={<SurveyAssign />} />
          <Route path="surveys/:id/analytics" element={<SurveyAnalytics />} />

          {/* Courses */}
          <Route path="courses" element={<ProtectedRoute permission="course_management_view"><Courses /></ProtectedRoute>} />
          <Route path="AllCourses" element={<ProtectedRoute permission="course_management_view"><AllCourses /></ProtectedRoute>} />
          <Route path="courses/module/:courseId" element={<ProtectedRoute permission="course_module_management_view"><CourseModule /></ProtectedRoute>} />
          <Route path="approvalRequest/view/:courseId" element={<AdminCourseView />} />
          <Route path="approvalRequest/view/:courseId/content/:moduleId" element={<AdminModuleContentView />} />
          <Route path="approvalRequest/view/:courseId/content/:moduleId/video/:contentId" element={<AdminVideoPlayerView />} />
          <Route path="approvalRequest/view/:courseId/content/:moduleId/document/:contentId" element={<AdminDocumentView />} />
          <Route path="approvalRequest/view/:courseId/content/:moduleId/quiz/:contentId" element={<AdminAssessmentView />} />
          <Route path="approvalRequest/view/:courseId/content/:moduleId/survey/:contentId" element={<AdminSurveyView />} />
          <Route path="courses/module/:courseId/content/:moduleId" element={<ProtectedRoute permission="course_module_management_view"><ModuleContent /></ProtectedRoute>} />

          <Route path="courses/module/:courseId/content/:moduleId/document/:contentId" element={<ProtectedRoute permission="course_module_management_view"><CourseDocument /></ProtectedRoute>} />
          <Route path="courses/module/:courseId/content/:moduleId/survey/:contentId" element={<ProtectedRoute permission="course_module_management_view"><CourseSurvey /></ProtectedRoute>} />
          <Route path="courses/module/:courseId/content/:moduleId/quiz/:contentId" element={<ProtectedRoute permission="course_module_management_view"><CourseQuiz /></ProtectedRoute>} />
          <Route path="courses/module/:courseId/content/:moduleId/video/:contentId" element={<ProtectedRoute permission="course_module_management_view"><VideoPlayer /></ProtectedRoute>} />



          {/* <Route path="courses/module/:courseId/content/:moduleId/video/:contentId" element={<CourseVideo />} /> */}


 

          <Route path="courses/create" element={<ProtectedRoute permission="course_management_create"><CreateCourse /></ProtectedRoute>} />
          <Route path="courses/edit-create/:courseId" element={<ProtectedRoute permission="course_management_edit"><CreateCourse /></ProtectedRoute>} />
          <Route path="courses/categories" element={<ProtectedRoute permission="course_management_view"><CourseCategories /></ProtectedRoute>} />

           {/* Course Analytics */}
          <Route path="courses/analytics/:courseId" element={<ProtectedRoute permission="course_management_view_analytics"><CourseAnalytics /></ProtectedRoute>} />
          <Route path="courses/analytics/:courseId/CourseAnalyticsAssessmentDetails/:assessmentId" element={<ProtectedRoute permission="course_management_view_analytics"><CourseAnalyticsAssessmentDetails /></ProtectedRoute>} />
          <Route path="courses/analytics/:courseId/CourseAnalyticsSurveyDetails/:surveyId" element={<ProtectedRoute permission="course_management_view_analytics"><CourseAnalyticsSurveyDetails /></ProtectedRoute>} />



          <Route path="CourseModule" element={<CourseModule />} />
          <Route path="CourseModuleContent" element={<ModuleContent />} />
          <Route path="CourseVideo" element={<CourseVideo />} />
          <Route path="CourseDocument" element={<CourseDocument />} />
          <Route path="CourseQuiz" element={<CourseQuiz />} />
          <Route path="CourseSurvey" element={<CourseSurvey />} />





          {/* Roles and Access */}
          <Route path="roles-and-access" element={<ProtectedRoute permission="roles_and_access_user_view"><RolesAndAccess /></ProtectedRoute>} />





          {/* Live Sessions */}
          <Route path="live-sessions" element={<ProtectedRoute permission="classroom_management_view"><AllClassroom /></ProtectedRoute>} />
          <Route path="live-sessions/classroom-dashboard/:classroomId" element={<ProtectedRoute permission="classroom_management_view"><ClassroomDashboard /></ProtectedRoute>} />
          <Route path="live-sessions/classroom-dashboard/:classroomId/trainees/:classroomId" element={<ProtectedRoute permission="classroom_management_view"><ClassroomTrainees /></ProtectedRoute>} />

          <Route path="ClassroomAssignments" element={<ProtectedRoute permission="classroom_management_view"><ClassroomAssignments /></ProtectedRoute>} />
          <Route path="live-sessions/classroom-dashboard/:classroomId/assingment/:assignmentId/ClassroomAssignmentDetails" element={<ProtectedRoute permission="classroom_management_view"><ClassrooomAssignmentDetails /></ProtectedRoute>} />

          <Route path="ClassroomAssessments" element={<ProtectedRoute permission="classroom_management_view"><ClassroomAssessments /></ProtectedRoute>} />
          <Route path="live-sessions/classroom-dashboard/:classroomId/assessment/:assessmentId/ClassroomAssessmentDetails" element={<ProtectedRoute permission="classroom_assessment_view"><ClassrooomAssessmentDetails /></ProtectedRoute>} />

          {/* Legacy routes - redirect to live-sessions */}
          <Route path="classrooms" element={<Navigate to="/admin/live-sessions" replace />} />
          <Route path="classrooms/*" element={<Navigate to="/admin/live-sessions" replace />} />
          <Route path="learning-spaces" element={<Navigate to="/admin/live-sessions" replace />} />
          <Route path="learning-spaces/*" element={<Navigate to="/admin/live-sessions" replace />} />




          {/* Question Bank (opens Live Sessions with Question Bank tab active) */}
          <Route path="question-bank" element={<AllClassroom defaultTab="questionBank" />} />



          
          <Route path="ClassroomLiveClasses" element={<ClassroomLiveClasses />} />
          <Route path="ClassroomCommunity" element={<ClassroomCommunity />} />


          {/* Trainees: redirect to Access Management (Trainees tab) */}
          <Route path="trainees" element={<Navigate to="/admin/roles-and-access" replace state={{ accessTab: 'trainees' }} />} />
          <Route path="traineesAnalytics/:traineeId" element={<TraineeAnalytics />} />

          {/* Certificates - under Courses tab */}
          <Route path="certificates" element={<Navigate to="/admin/courses?tab=certificates" replace />} />

          {/* Announcement */}
          <Route path="announcement" element={<ProtectedRoute permission="announcement_management_view"><Announcement /></ProtectedRoute>} />

          {/* Approval Requests */}
          <Route path="approvalRequest" element={<ProtectedRoute permission="course_approval_workflow_view_analytics"><ApprovalRequest /></ProtectedRoute>} />

          {/* Notifications */}
          <Route path="notifications" element={<Notifications />} />
          <Route path="notifications/:id" element={<NotificationDetails />} />

          {/* Settings */}
          <Route path="settings" element={<Settings />} />

          {/* Documents */}
          <Route path="organization-docs" element={<ProtectedRoute permission="setting_management_view"><OrganizationDocs /></ProtectedRoute>} />


          {/* Prompt Assistant */}
          <Route path="prompt-assistant" element={<PromptAssistant />} />



        </Route>
      </Routes> 
      <ToastContainer limit={3} />
    </>
  );
}

export default AdminRoutes;

